import RestService from '../services/rest';

// GET
async function getDailyLoadCarriers(position, branchCode) {
  return await RestService.getAuthenticated('dailyLoadCarriers/dailyLoadBase', { position, branchCode });
}

// POST
async function searchCarriers(searchParams) {
  return RestService.postAuthenticated('dailyLoadCarriers/searchCarriers', searchParams);
}

async function linkDailyLoadCarrier(carrierId, dailyLoadId, position, branchCode) {
  return RestService.postAuthenticated('dailyLoadCarriers/link', {
    carrierId, dailyLoadId, position, branchCode,
  });
}

async function unlinkDailyLoadCarrier(dailyLoadCarrierId) {
  return RestService.postAuthenticated('dailyLoadCarriers/unlink', { dailyLoadCarrierId });
}

export default {
  getDailyLoadCarriers,
  searchCarriers,
  linkDailyLoadCarrier,
  unlinkDailyLoadCarrier,
};
